import moment from 'moment';
import {
    ALERTS_MANAGEMENT_OPTIONS_TYPES,
    DEFAULT_POLICY_ID,
    HTTP_OPTIONS,
    SECURITY_EVENTS_TYPES
} from '@silverfort-nodelibs/common/utils/consts';
import Loader from '../../../../Controls/Loader/Loader';
import List from '../../../../sf-components/List/List';
import Checkbox from '../../../../sf-components/Checkbox/Checkbox';
import ListItem from '../../../../sf-components/List/ListItem';
import { Drawer } from '@material-ui/core';
import Button from '../../../../sf-components/Button/Button';
import ButtonStyles from '../../../../sf-components/Button/ButtonStyles';
import Icons from '../../../../sf-components/Icon/Icons';
import { useEffect, useState } from 'react';
import { httpGet, httpPost } from '../../../../utils';
import Radio from '../../../../sf-components/Radio/Radio';
import { Modal } from 'react-bootstrap';
import Label from '../../../../sf-components/Label/Label';
import Toggle from '../../../../sf-components/Toggle/Toggle';
import Search from '../../../../sf-components/Search/Search';
import { SYSLOG_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { Dropdown } from '@silverfort/sf-components';

const buildEventSettings = ({
    data,
    eventSettings,
    eventInEdit,
    eventSelections,
    setEventSelections,
    policies,
    searchTerm,
    hiddenIncidentTypes
}) => {
    if (!eventInEdit) return;
    let selections = eventSelections || data.settings?.[eventInEdit] || [];
    let options = eventSettings.options;

    if (eventInEdit === SECURITY_EVENTS_TYPES.POLICY_MATCH.id) {
        if (!policies) {
            return <Loader />;
        }

        options = policies;
        selections = eventSelections || data.settings?.[eventInEdit] || [];
    }

    if (eventInEdit === SYSLOG_TYPES.INTEGRATIONS.id && selections.length === 0) {
        selections = [data.splunkTimezone] || ['UTC'];
    }

    if ([SECURITY_EVENTS_TYPES.NEW_INCIDENT.id, SECURITY_EVENTS_TYPES.INCIDENT_AUTH_LOGS.id].includes(eventInEdit)) {
        if (!hiddenIncidentTypes) {
            return <Loader />;
        }

        options = options.filter((option) => !hiddenIncidentTypes.has(option.value));
    }

    const calcSelectionsValue = (value) => {
        let newSelections;
        const filteredSelections = selections.filter((selection) => selection.toString() !== value.toString());
        if (filteredSelections.length < selections.length) {
            newSelections = filteredSelections;
        } else {
            newSelections = [...selections, value];
        }

        setEventSelections(newSelections);
    };

    const calcSelectionsCount = (selections, options) => {
        return options.filter((option) => selections.includes(option.value)).length;
    };

    const calcSelectAllStatus = (selections, options) => {
        const selectedOptionsCount = calcSelectionsCount(selections, options);
        if (selectedOptionsCount === options.length) return 'checked';
        if (selectedOptionsCount > 0) return 'indeterminate';
        return 'unchecked';
    };

    const handleSelecttionChange = (selectedItems) => {
        setEventSelections(selectedItems);
        selections = [selectedItems];
    };

    const sortTimeZone = (tz1, tz2) => {
        const tzDiff = moment.tz(tz1.value).utcOffset() - moment.tz(tz2.value).utcOffset();
        if (tzDiff === 0) {
            return tz1.title.localeCompare(tz2.title);
        }
        return tzDiff;
    };

    const optionsView = (options, optionType, optionsKey) => {
        options?.sort((a, b) => a.label.localeCompare(b.label));
        const selectAllStatus = calcSelectAllStatus(selections, options);
        return (
            <>
                {optionType === ALERTS_MANAGEMENT_OPTIONS_TYPES.RADIO && (
                    <div className="py-2">
                        {options.map((option, i) => (
                            <div key={i} className="flex px-2 py-0.5 items-center">
                                <Radio
                                    id={`${optionsKey}${i}`}
                                    value={option.value}
                                    onChange={(value) => {
                                        // if multiple options groups, remove all the current group values, and add the currently selected one
                                        if (optionsKey) {
                                            const optionsValues = options.map((option) => option.value);
                                            const newSelections = selections.filter(
                                                (selection) => !optionsValues.includes(selection)
                                            );

                                            newSelections.push(value);
                                            setEventSelections(newSelections);
                                        } else {
                                            setEventSelections([value]);
                                        }
                                    }}
                                    checked={selections.includes(option.value)}
                                />
                                <span className="text-13 text-sf-gray-800 ml-2">{option.label}</span>
                            </div>
                        ))}
                    </div>
                )}
                {optionType === ALERTS_MANAGEMENT_OPTIONS_TYPES.TOGGLE && (
                    <div className="flex items-center py-2">
                        <Toggle
                            checked={selections.includes(options[0].value)}
                            onChange={() => {
                                if (selections.includes(options[0].value)) {
                                    const newSelections = selections.filter(
                                        (selection) => selection.toString() !== options[0].value.toString()
                                    );
                                    setEventSelections(newSelections);
                                } else {
                                    const newSelections = [...selections, options[0].value];
                                    setEventSelections(newSelections);
                                }
                            }}
                        />
                        <span className="text-13 text-sf-gray-800 mb-1 ml-2">{options[0].label}</span>
                    </div>
                )}
                {optionType === ALERTS_MANAGEMENT_OPTIONS_TYPES.CHECKBOX && (
                    <List className="w-full px-[0px]">
                        {!!options.length && (
                            <>
                                <div className="text-12 px-2 font-medium text-sf-gray-500">
                                    Selections{' '}
                                    {!eventSettings.singleOption && `(${calcSelectionsCount(selections, options)})`}
                                </div>
                                <div className="flex px-2 items-center h-8">
                                    <Checkbox
                                        checked={selectAllStatus === 'checked'}
                                        indeterminate={selectAllStatus === 'indeterminate'}
                                        onChange={() => {
                                            // if multiple options groups, remove all/add all the options of the current category,
                                            // and don't effect other categories
                                            if (optionsKey) {
                                                const optionsValues = options.map((option) => option.value);
                                                const selectedCategoryOptions = selections.filter((selection) =>
                                                    optionsValues.includes(selection)
                                                );
                                                const newSelections = selections.filter(
                                                    (selection) => !optionsValues.includes(selection)
                                                );

                                                if (selectedCategoryOptions.length !== options.length) {
                                                    newSelections.push(...optionsValues);
                                                }

                                                setEventSelections(newSelections);
                                            } else {
                                                selections.length === options.length
                                                    ? setEventSelections([])
                                                    : setEventSelections(options.map((option) => option.value));
                                            }
                                        }}
                                    />
                                    <span className="text-13 font-medium ml-2">Select All</span>
                                </div>
                            </>
                        )}
                        {options.map((option, i) => {
                            return (
                                <ListItem
                                    key={i}
                                    label={option.label}
                                    value={option.value}
                                    desc={option.desc}
                                    selected={
                                        !!selections.filter(
                                            (selection) => selection.toString() === option.value.toString()
                                        ).length
                                    }
                                    checkable={'true'}
                                    onCheck={(value) => calcSelectionsValue(value)}
                                />
                            );
                        })}
                    </List>
                )}
                {optionType === ALERTS_MANAGEMENT_OPTIONS_TYPES.SELECT && (
                    <Dropdown
                        className="w-full"
                        title="Time zone"
                        items={options
                            .map((option) => ({ title: option.label, value: option.value }))
                            .sort(sortTimeZone)}
                        selectedItems={selections}
                        onChange={handleSelecttionChange}
                        variant="trigger"
                        searchable
                        width="full"
                    />
                )}
            </>
        );
    };
    return (
        <div className="h-full py-4">
            {eventSettings.multiOptions ? (
                Object.keys(options).map((optionsKey) => {
                    return (
                        <div key={optionsKey} className="flex flex-col">
                            <Label className="px-2 text-sf-gray-400" text={optionsKey} />
                            {optionsView(
                                options[optionsKey].options,
                                options[optionsKey].optionType || ALERTS_MANAGEMENT_OPTIONS_TYPES.CHECKBOX,
                                optionsKey
                            )}
                        </div>
                    );
                })
            ) : (
                <div>
                    {optionsView(
                        searchTerm
                            ? options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()))
                            : options,
                        eventSettings.optionType || ALERTS_MANAGEMENT_OPTIONS_TYPES.CHECKBOX
                    )}
                </div>
            )}
        </div>
    );
};

const EventSettingsDrawer = ({
    alertType = '',
    data,
    eventSettings,
    eventInEdit,
    eventSelections,
    example = undefined,
    setEventSelections,
    setEventInEdit,
    setData
}) => {
    const [policies, setPolicies] = useState();
    const [hiddenIncidentTypes, setHiddenIncidentTypes] = useState();
    const [exampleToExpand, setExampleToExpand] = useState();
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const getPolicies = async () => {
            const response = await httpGet(`/policy/rules`, {
                [HTTP_OPTIONS.HANDLE_ERRORS]: true
            });

            if (!response.data) {
                console.error('Failed to retrieve policies');
                setPolicies([]);
            } else {
                setPolicies(
                    response.data.Rules.filter((policy) => {
                        if (searchTerm) {
                            return (
                                policy.id !== DEFAULT_POLICY_ID &&
                                policy.name.toLowerCase().includes(searchTerm.toLowerCase())
                            );
                        } else {
                            return policy.id !== DEFAULT_POLICY_ID;
                        }
                    }).map((policy) => {
                        return { desc: 'ID ' + policy.id, value: policy.id, label: policy.name };
                    })
                );
            }
        };

        getPolicies();
    }, [searchTerm]);

    useEffect(() => {
        const getHiddenIncidentTypes = async () => {
            const response = await httpPost(
                '/risk/incidents',
                {},
                {
                    [HTTP_OPTIONS.HANDLE_ERRORS]: true
                }
            );
            if (response.data) {
                setHiddenIncidentTypes(new Set(response.data.hiddenIncidentTypes));
            }
        };

        getHiddenIncidentTypes();
    }, [setHiddenIncidentTypes]);

    const updateSettingsObject = (data) => {
        if (eventInEdit === SYSLOG_TYPES.INTEGRATIONS.id) {
            setData({
                ...data,
                splunkTimezone: eventSelections
            });
        } else {
            setData({
                ...data,
                settings: { ...data.settings, [eventInEdit]: eventSelections }
            });
        }
    };

    return (
        <>
            <Drawer
                variant="persistent"
                open={!!eventInEdit}
                onClose={() => {
                    setEventInEdit(null);
                    setSearchTerm('');
                }}
                anchor="right"
                PaperProps={{
                    className: 'w-[334px] shadow-sf-medium'
                }}>
                <div className="font-sf flex flex-col justify-between h-full">
                    <div className="h-full flex flex-col justify-between">
                        <div
                            className={`${
                                eventSettings?.desc ? 'h-36' : 'h-16'
                            } py-5 px-6 border-b border-sf-gray-100`}>
                            <div className="text-14 h-6 font-medium">
                                {eventSettings?.title?.replaceAll('{alertType}', alertType)}
                            </div>
                            <p className="text-12 leading-[18px]">
                                {eventSettings?.desc?.replaceAll('{alertType}', alertType)}
                            </p>
                        </div>
                        {(!eventSettings?.optionType ||
                            eventSettings?.optionType === ALERTS_MANAGEMENT_OPTIONS_TYPES.CHECKBOX) &&
                            !eventSettings?.multiOptions && (
                                <div className="flex items-center border-b border-sf-gray-100">
                                    <Search
                                        id={eventSettings?.title + '-Search'}
                                        className="w-full p-[16px] h-[40px]"
                                        onChange={(text) => setSearchTerm(text)}
                                    />
                                </div>
                            )}
                        <div className="border-b flex flex-col justify-start px-2 border-sf-gray-100 grow h-80 overflow-auto">
                            {buildEventSettings({
                                data,
                                eventSettings,
                                eventInEdit,
                                eventSelections,
                                setEventSelections,
                                policies,
                                searchTerm,
                                hiddenIncidentTypes
                            })}
                        </div>
                        {example && eventInEdit === SECURITY_EVENTS_TYPES.NEW_INCIDENT.id && (
                            <div className="relative px-6 py-4 min-h-40">
                                <div className="mb-2 text-12 font-medium text-sf-gray-500">Example</div>
                                <textarea
                                    disabled
                                    value={JSON.stringify(example, null, 2)}
                                    className="peer hover:border-sf-gray-300 transition duration-300 w-full h-32 resize-none rounded-lg border border-sf-gray-100 bg-sf-gray-50 text-13 text-sf-gray-500 p-2 pb-0 overflow-auto"></textarea>
                                <div className="flex absolute top-12 right-10 invisible justify-end  hover:visible peer-hover:visible ">
                                    <Button
                                        className="mr-1"
                                        buttonStyle={ButtonStyles.Tertiary}
                                        iconLeft={Icons.Copy}
                                        onClick={() => navigator.clipboard.writeText(JSON.stringify(example, null, 2))}
                                    />
                                    <Button
                                        buttonStyle={ButtonStyles.Tertiary}
                                        iconLeft={Icons.Expand}
                                        onClick={() => setExampleToExpand(JSON.stringify(example, null, 2))}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="border-t border-sf-gray-100 px-6 min-h-14 h-14 flex justify-end items-center">
                        <Button
                            onClick={() => {
                                setEventSelections(null);
                                setEventInEdit(null);
                                setSearchTerm('');
                            }}
                            text={'Cancel'}
                            buttonStyle={ButtonStyles.TertiarySolid}
                            className={'mr-2'}
                        />
                        <Button
                            disabled={!eventSelections}
                            onClick={() => {
                                updateSettingsObject(data);
                                setEventInEdit(null);
                                setEventSelections(null);
                                setSearchTerm('');
                            }}
                            text={'Apply'}
                        />
                    </div>
                </div>
            </Drawer>
            {exampleToExpand && (
                <Modal
                    className="font-sf flex flex-col justify-center"
                    id={'exampleModal'}
                    dialogClassName="w-[560px] [&_.modal-content]:rounded-lg [&_.modal-content]:shadow-modal-light"
                    show
                    onHide={() => setExampleToExpand()}
                    keyboard={false}
                    backdrop="static">
                    <Modal.Header className="border-hidden pt-4 pr-6 pb-0 pl-0" closeButton>
                        <div className="px-4 pb-4 mb-1 text-14 font-medium text-sf-gray-800">Code Example</div>
                    </Modal.Header>
                    <Modal.Body className=" text-13 px-4 pb-6 h-full border-t border-b">
                        <textarea
                            disabled
                            value={exampleToExpand}
                            className="w-full h-96 resize-none rounded-lg border border-sf-gray-100 bg-sf-gray-50 text-13 text-sf-gray-500 p-2 pb-0 overflow-auto"></textarea>
                    </Modal.Body>
                    <Modal.Footer className="border-hidden px-6">
                        <div className="flex justify-end items-center">
                            <Button
                                onClick={() => setExampleToExpand()}
                                text={'Cancel'}
                                buttonStyle={ButtonStyles.TertiarySolid}
                                className={'mr-2'}
                            />
                            <Button
                                iconLeft={Icons.Copy}
                                onClick={() => {
                                    navigator.clipboard.writeText(exampleToExpand);
                                    setExampleToExpand();
                                }}
                                text={'Copy to clipboard'}
                            />
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

export default EventSettingsDrawer;
